import { render, staticRenderFns } from "./AmountField.vue?vue&type=template&id=a3397052&"
import script from "./AmountField.vue?vue&type=script&lang=js&"
export * from "./AmountField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports